module.exports = {
	"title": "CSS Gradients",
	"description": "Method of defining a linear or radial color gradient as a CSS image.",
	"spec": "http://www.w3.org/TR/css3-images/",
	"status": "cr",
	"links": [
		{
			"url": "http://www.colorzilla.com/gradient-editor/",
			"title": "Cross-browser editor"
		},
		{
			"url": "http://www.css3files.com/gradient/",
			"title": "Information page"
		},
		{
			"url": "http://css3pie.com/",
			"title": "Tool to emulate support in IE"
		},
		{
			"url": "http://docs.webplatform.org/wiki/css/functions/linear-gradient",
			"title": "WebPlatform Docs"
		}
	],
	"bugs": [],
	"categories": [
		"CSS3"
	],
	"stats": {
		"ie": {
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "y",
			"11": "y",
			"5.5": "n"
		},
		"edge": {
			"12": "y",
			"13": "y",
			"14": "y"
		},
		"firefox": {
			"2": "n",
			"3": "n",
			"4": "y x",
			"5": "y x",
			"6": "y x",
			"7": "y x",
			"8": "y x",
			"9": "y x",
			"10": "y x",
			"11": "y x",
			"12": "y x",
			"13": "y x",
			"14": "y x",
			"15": "y x",
			"16": "y",
			"17": "y",
			"18": "y",
			"19": "y",
			"20": "y",
			"21": "y",
			"22": "y",
			"23": "y",
			"24": "y",
			"25": "y",
			"26": "y",
			"27": "y",
			"28": "y",
			"29": "y",
			"30": "y",
			"31": "y",
			"32": "y",
			"33": "y",
			"34": "y",
			"35": "y",
			"36": "y",
			"37": "y",
			"38": "y",
			"39": "y",
			"40": "y",
			"41": "y",
			"42": "y",
			"43": "y",
			"44": "y",
			"45": "y",
			"46": "y",
			"47": "y",
			"48": "y",
			"49": "y",
			"50": "y",
			"51": "y",
			"52": "y",
			"53": "y",
			"3.5": "n",
			"3.6": "y x"
		},
		"chrome": {
			"4": "a x",
			"5": "a x",
			"6": "a x",
			"7": "a x",
			"8": "a x",
			"9": "a x",
			"10": "y x",
			"11": "y x",
			"12": "y x",
			"13": "y x",
			"14": "y x",
			"15": "y x",
			"16": "y x",
			"17": "y x",
			"18": "y x",
			"19": "y x",
			"20": "y x",
			"21": "y x",
			"22": "y x",
			"23": "y x",
			"24": "y x",
			"25": "y x",
			"26": "y",
			"27": "y",
			"28": "y",
			"29": "y",
			"30": "y",
			"31": "y",
			"32": "y",
			"33": "y",
			"34": "y",
			"35": "y",
			"36": "y",
			"37": "y",
			"38": "y",
			"39": "y",
			"40": "y",
			"41": "y",
			"42": "y",
			"43": "y",
			"44": "y",
			"45": "y",
			"46": "y",
			"47": "y",
			"48": "y",
			"49": "y",
			"50": "y",
			"51": "y",
			"52": "y",
			"53": "y",
			"54": "y",
			"55": "y",
			"56": "y",
			"57": "y"
		},
		"safari": {
			"4": "a x",
			"5": "a x",
			"6": "y x",
			"7": "y",
			"8": "y",
			"9": "y",
			"10": "y",
			"3.1": "n",
			"3.2": "n",
			"5.1": "y x",
			"6.1": "y",
			"7.1": "y",
			"9.1": "y",
			"TP": "y"
		},
		"opera": {
			"9": "n",
			"11": "n",
			"12": "y x",
			"15": "y",
			"16": "y",
			"17": "y",
			"18": "y",
			"19": "y",
			"20": "y",
			"21": "y",
			"22": "y",
			"23": "y",
			"24": "y",
			"25": "y",
			"26": "y",
			"27": "y",
			"28": "y",
			"29": "y",
			"30": "y",
			"31": "y",
			"32": "y",
			"33": "y",
			"34": "y",
			"35": "y",
			"36": "y",
			"37": "y",
			"38": "y",
			"39": "y",
			"40": "y",
			"41": "y",
			"42": "y",
			"43": "y",
			"9.5-9.6": "n",
			"10.0-10.1": "n",
			"10.5": "n",
			"10.6": "n",
			"11.1": "a x #1",
			"11.5": "a x #1",
			"11.6": "y x",
			"12.1": "y"
		},
		"ios_saf": {
			"8": "y",
			"10": "y",
			"3.2": "a x",
			"4.0-4.1": "a x",
			"4.2-4.3": "a x",
			"5.0-5.1": "y x",
			"6.0-6.1": "y x",
			"7.0-7.1": "y",
			"8.1-8.4": "y",
			"9.0-9.2": "y",
			"9.3": "y"
		},
		"op_mini": {
			"all": "n"
		},
		"android": {
			"3": "a x",
			"4": "y x",
			"53": "y",
			"2.1": "a x",
			"2.2": "a x",
			"2.3": "a x",
			"4.1": "y x",
			"4.2-4.3": "y x",
			"4.4": "y",
			"4.4.3-4.4.4": "y"
		},
		"bb": {
			"7": "a x",
			"10": "y"
		},
		"op_mob": {
			"10": "n",
			"11": "n",
			"12": "y x",
			"37": "y",
			"11.1": "a x #1",
			"11.5": "a x #1",
			"12.1": "y"
		},
		"and_chr": {
			"53": "y"
		},
		"and_ff": {
			"49": "y"
		},
		"ie_mob": {
			"10": "y",
			"11": "y"
		},
		"and_uc": {
			"11": "y x"
		},
		"samsung": {
			"4": "y"
		}
	},
	"notes": "Syntax used by browsers with prefixed support may be incompatible with that for proper support.\r\n\r\nSupport can be somewhat emulated in older IE versions using the non-standard \"gradient\" filter. \r\n\r\nFirefox 10+, Opera 11.6+, Chrome 26+ and IE10+ also support the new \"to (side)\" syntax.",
	"notes_by_num": {
		"1": "Partial support in Opera 11.10 and 11.50 also refers to only having support for linear gradients."
	},
	"usage_perc_y": 92.8,
	"usage_perc_a": 0.18,
	"ucprefix": false,
	"parent": "",
	"keywords": "linear,linear-gradient,gradiant",
	"ie_id": "gradients",
	"chrome_id": "5785905063264256",
	"firefox_id": "",
	"webkit_id": "",
	"shown": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/css-gradients.json
 ** module id = 420
 ** module chunks = 0
 **/